<template>
  <div class="shortlist-view-container">
    <div class="shortlist-view">
      <div class="shortlist-view-nav-container" v-if="!publicView">
        <div class="back-btn button-slide-hover" @click="returnToPreviousSubpage">
          <svg xmlns="http://www.w3.org/2000/svg">
            <image xlink:href="/images/icons/chevron-left.svg" />
          </svg>
          BACK
        </div>
        <div class="shortlist-view-nav">
          <div class="shortlist-view-share" @click="openShareModal(shortlist)">
            <span>Share</span>
            <svg xmlns="http://www.w3.org/2000/svg">
              <image xlink:href="/images/icons/export.svg" />
            </svg>
          </div>
          <div class="shortlist-view-edit" @click="editShortlist(shortlist)">
            Edit
            <svg xmlns="http://www.w3.org/2000/svg">
              <image xlink:href="/images/icons/edit-v3.svg" />
            </svg>
          </div>
        </div>
      </div>
      <template v-if="shortlist">
        <div class="shortlist-view-header-container">
          <div class="shortlist-view-header">
            {{ shortlist.label }}
          </div>
          <div class="shortlist-view-col-2">
            <div class="shortlist-details-header shortlist-owner" v-if="publicView">Owner:</div>
            <div class="shortlist-details-agency" v-if="shortlist.agency_name">
              <div class="shortlist-details-header">Agency Name</div>
              <div class="shortlist-details-value">{{ shortlist.agency_name }}</div>
            </div>
          </div>
          <div class="shortlist-view-col-3">
            <div class="shortlist-details-value shortlist-owner" v-if="publicView">{{ shortlist.created_by_name }}</div>
            <div class="shortlist-details-brand" v-if="shortlist.brand_name">
              <div class="shortlist-details-header">Brand Name</div>
              <div class="shortlist-details-value">{{ shortlist.brand_name }}</div>
            </div>
          </div>
          <div class="shortlist-details-header-mobile-container">
            <div class="shortlist-details-header-mobile">
              <div class="shortlist-details-agency" v-if="shortlist.agency_name">
                <div class="shortlist-details-header">Agency Name</div>
                <div class="shortlist-details-value">{{ shortlist.agency_name }}</div>
              </div>
              <div class="shortlist-details-brand" v-if="shortlist.brand_name">
                <div class="shortlist-details-header">Brand Name</div>
                <div class="shortlist-details-value">{{ shortlist.brand_name }}</div>
              </div>
            </div>
            <div class="shortlist-details-owner" v-if="publicView">
              <div class="shortlist-details-header">Owner: </div>
              <div class="shortlist-details-value">{{ shortlist.created_by_name }}</div>
            </div>
          </div>
        </div>
        <div class="shortlist-view-blocks">
          <loader :loading="loading" :fixed="true"></loader>
          <template v-if="listings && listings.data">
            <listing-card
              v-for="listing in listings.data.slice(0, 3)"
              :key="listing.id"
              :listing="listing"
              :shortlist="shortlist"
              :removeListing="removeListing"
            ></listing-card>
            <div v-if="listings.data.length < 3" class="tablet-hidden" v-for="index in 3 - (listings.data.length > 3 ? 3 : listings.data.length)"></div>
            <div class="tablet-hidden">
              <div class="lets-chat-block">
                <div class="lets-chat-center">
                  <div class="question-block">
                    <svg xmlns="http://www.w3.org/2000/svg">
                      <image xlink:href="/images/icons/message-question.svg" />
                    </svg>
                  </div>
                  <div class="lets-chat-heading">Need something more?</div>
                  <div class="lets-chat-text">Let us know what you need and we can assist you</div>
                  <div class="lets-chat-btn-container">
                    <button class="button lets-chat-btn-transparent" @click="openChat">Let's Chat</button>
                  </div>
                </div>
              </div>
            </div>
            <listing-card
              v-for="listing in listings.data.slice(3)"
              :key="listing.id"
              :listing="listing"
              :shortlist="shortlist"
              :removeListing="removeListing"
            ></listing-card>
          </template>
        </div>
        <div class="pagination" v-if="listings && listings.data && listings.data.length">
          <pagination
            :current-page="page"
            :total-pages="totalPages"
            @change-page="changePage"
          ></pagination>

          <div class="pagination-label">
            {{ listings.from }} - {{ listings.to }} of
            {{ listings.total }} spaces
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ListingCard from './ListingCard';
export default {
  components: {
    ListingCard
  },
  data() {
    return {
      listings: null,
      currentPath: null,
      loading: false,
      page: 1,
      totalPages: 1,
    }
  },
  methods: {
    returnToPreviousSubpage() {
      this.$store.commit('findspace/navigatePreviousSubpage')
    },
    changePage(which) {
      this.page = which;
      this.getListings();
    },
    getListings() {
      this.loading = true;
      axios.get(`/api/public/shortlist/${this.shortlist.public_token}/listings?page=${this.page}`)
        .then((response) => {
          this.listings = response.data;
          this.totalPages = Math.ceil(response.data.total / 6);

          this.loading = false;

          if (this.publicView) {
            this.$store.dispatch("intercom/track", {
              type: "User access to shared shortlist",
              meta: {
                  label: this.shortlist.label,
                  agency_name: this.shortlist.agency_name,
                  brand_name: this.shortlist.brand_name
              },
            });
            console.log('Intercom New: User access to shared shortlist', {label: this.shortlist.label, agency_name: this.shortlist.agency_name, brand_name: this.shortlist.brand_name});
          }
        })
        .catch(() => {
          this.loading = false;
        })
    },
    removeListing(listing) {
        this.loading = true;
        this.$store.dispatch("user/toggleShortlistProperties", {
            shortlistId: this.shortlist.id,
            listings: [listing],
            shortlisted: false,
        })
        .then(() => {
            // Track the search
            this.$store.dispatch("intercom/track", {
                type: "Unshortlist Property",
                meta: {
                    shortlistId: this.shortlist.id,
                    listingId: listing.id,
                    name: listing.name,
                },
            });
            this.getListings();
        })
        .catch((e) => {
            this.$toasted.show(
                "Your shortlists could not be updated, please reload the page and try again.",
                { type: "error" }
            );
            this.loading = false;
        });
    },
    editShortlist(shortlist) {
      this.$store
        .dispatch("modals/show", {
          title: "Edit shortlist",
          type: "shortlist-add",
          maskCanDismiss: false,
          narrow: true,
          data: shortlist
        })
        .then((response) => {
          const currentShortlist = this.shortlist;
          currentShortlist.agency_name = response.related.shortlist.agency_name;
          currentShortlist.brand_name = response.related.shortlist.brand_name;
          currentShortlist.label = response.related.shortlist.label;
          this.$store.commit('findspace/setItem', { item: currentShortlist });
        })
        .catch(() => {});
    },
    openShareModal(shortlist) {
      this.$store
        .dispatch("modals/show", {
          type: "shortlist-share",
          maskCanDismiss: false,
          headless: true,
          narrow: true,
          data: {
            shortlist: shortlist
          }
        });
    },
    openChat() {
      this.$store.dispatch("intercom/openNewChat");
    }
  },
  mounted() {
    this.getListings();
    this.currentPath = window.location.pathname;
  },
  computed: {
    shortlist() {
      return this.$store.getters['findspace/item'];
    },
    publicView() {
      return this.$store.getters['findspace/public']
    }
  }
}
</script>
